module.exports = __webpack_public_path__ + "static/epv_canal-967eafe98031f82e34b537ba2967a8cb.jpg";